export type RenderAssetStatus = "available" | "external" | "fallback" | "blocked";

export type RenderAssetSource = {
  project: "AllWebsite" | "insparkle-new";
  path: string;
  originalId?: string;
};

export type RenderMetalAsset = {
  id: string;
  label: string;
  prefix: string;
  swatch: string;
  color: string;
  metalness: number;
  roughness: number;
  clearcoat: number;
  envMapIntensity: number;
  reflectivity: number;
  thumbnailUrl?: string;
  baseColorMapUrl?: string | null;
  normalMapUrl?: string | null;
  aoMapUrl?: string | null;
  roughnessMapUrl?: string | null;
  metalnessMapUrl?: string | null;
  source: RenderAssetSource;
  status: RenderAssetStatus;
  notes: string;
};

export type RenderGemstoneAsset = {
  id: string;
  label: string;
  prefix: string;
  swatch: string;
  color: string;
  transmission: number;
  ior: number;
  thickness: number;
  roughness: number;
  envMapIntensity: number;
  attenuationColor: string;
  attenuationDistance: number;
  dispersion: number;
  internalColorStrength: number;
  outerReflectionMix?: number;
  maxOuterReflection?: number;
  refractionDepth?: number;
  refractionCount?: number;
  maxReflection: number;
  mixedReflection: boolean;
  thumbnailUrl?: string;
  source: RenderAssetSource;
  status: RenderAssetStatus;
  notes: string;
};

export type RenderHdrAsset = {
  id: string;
  label: string;
  alias: string;
  prefix: string;
  background: string;
  thumbnailColor: string;
  exposure: number;
  environmentIntensity: number;
  thumbnailUrl?: string;
  hdrUrl?: string;
  source: RenderAssetSource;
  status: RenderAssetStatus;
  notes: string;
};

export const renderMetalAssets: RenderMetalAsset[] = [
  {
    "id": "metal-brown",
    "label": "棕色",
    "prefix": "brown",
    "swatch": "#9b5b35",
    "color": "#9b5b35",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-brown.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-yellow",
    "label": "黄色",
    "prefix": "yellow",
    "swatch": "#f0d300",
    "color": "#f0d300",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-yellow.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-purple",
    "label": "紫色",
    "prefix": "purple",
    "swatch": "#6e2a91",
    "color": "#6e2a91",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-purple.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-blue",
    "label": "蓝色",
    "prefix": "blue",
    "swatch": "#0046b7",
    "color": "#0046b7",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-blue.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-green",
    "label": "绿色",
    "prefix": "green",
    "swatch": "#007c38",
    "color": "#007c38",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-green.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-light-yellow",
    "label": "浅黄色",
    "prefix": "light_yellow",
    "swatch": "#f1df79",
    "color": "#f1df79",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-light-yellow.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-light-green",
    "label": "浅绿色",
    "prefix": "light_green",
    "swatch": "#a6bc76",
    "color": "#a6bc76",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-light-green.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-sky-blue",
    "label": "天蓝色",
    "prefix": "sky_blue",
    "swatch": "#00a3cc",
    "color": "#00a3cc",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-sky-blue.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-pink",
    "label": "粉红色",
    "prefix": "pink",
    "swatch": "#d99699",
    "color": "#d99699",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-pink.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-pearl",
    "label": "珍珠",
    "prefix": "珍珠",
    "swatch": "#e3e2e1",
    "color": "#e3e2e1",
    "metalness": 0.3,
    "roughness": 0.3,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-pearl.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6189520"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-black",
    "label": "黑色",
    "prefix": "whit_black",
    "swatch": "#2e2e2e",
    "color": "#2e2e2e",
    "metalness": 1.0,
    "roughness": 0.0,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-black.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5919396"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-red",
    "label": "红色",
    "prefix": "red",
    "swatch": "#850104",
    "color": "#850104",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-red.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-yellow-matte",
    "label": "18K黄磨砂",
    "prefix": "Yellow_matte",
    "swatch": "#efd99f",
    "color": "#efd99f",
    "metalness": 1.2,
    "roughness": 0.0,
    "clearcoat": 0.36,
    "envMapIntensity": 1.12,
    "reflectivity": 0.95,
    "thumbnailUrl": "/render-assets/materials/metal-18k-yellow-matte.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6198400"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-yellow",
    "label": "18K黄",
    "prefix": "18K_Yellow_Gold_01_N",
    "swatch": "#efd34d",
    "color": "#efd34d",
    "metalness": 1.0,
    "roughness": 0.0,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-18k-yellow.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612612"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-yellow-brushed",
    "label": "18K黄拉丝",
    "prefix": "18K_Yellow_brushed_Gold_01_N",
    "swatch": "#d9b443",
    "color": "#d9b443",
    "metalness": 1.0,
    "roughness": 0.01,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-18k-yellow-brushed.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612613"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-white-brushed",
    "label": "18K白拉丝",
    "prefix": "white_sand",
    "swatch": "#dadbd7",
    "color": "#dadbd7",
    "metalness": 1.2,
    "roughness": 0.0,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-18k-white-brushed.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6126770"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-white-matte",
    "label": "18K白磨砂",
    "prefix": "whit_matte",
    "swatch": "#d9dad6",
    "color": "#d9dad6",
    "metalness": 1.2,
    "roughness": 0.0,
    "clearcoat": 0.36,
    "envMapIntensity": 1.12,
    "reflectivity": 0.95,
    "thumbnailUrl": "/render-assets/materials/metal-18k-white-matte.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6198396"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-white",
    "label": "18K白",
    "prefix": "whit_gold",
    "swatch": "#f2f2ef",
    "color": "#f2f2ef",
    "metalness": 1.2,
    "roughness": 0.0,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-18k-white.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612596"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-red",
    "label": "18K红",
    "prefix": "18K_red",
    "swatch": "#e1b99b",
    "color": "#e1b99b",
    "metalness": 1.3,
    "roughness": 0.0,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-18k-red.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6133065"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-red-matte",
    "label": "18K红磨砂",
    "prefix": "red_Sandblasting",
    "swatch": "#DDBBA8",
    "color": "#DDBBA8",
    "metalness": 1.0,
    "roughness": 0.0,
    "clearcoat": 0.36,
    "envMapIntensity": 1.12,
    "reflectivity": 0.95,
    "thumbnailUrl": "/render-assets/materials/metal-18k-red-matte.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6197421"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-18k-red-brushed",
    "label": "18K红拉丝",
    "prefix": "red_sand_drawing",
    "swatch": "#e1b99b",
    "color": "#e1b99b",
    "metalness": 1.3,
    "roughness": 0.1,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-18k-red-brushed.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6154996"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-pure-gold-brushed",
    "label": "足金拉丝",
    "prefix": "5G_Gold_brushed_Bracelet_01_N",
    "swatch": "#e7be55",
    "color": "#e7be55",
    "metalness": 1.0,
    "roughness": 0.18,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-pure-gold-brushed.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-pure-gold-sandblasted",
    "label": "足金喷砂",
    "prefix": "足金磨砂",
    "swatch": "#e7be55",
    "color": "#e7be55",
    "metalness": 1.0,
    "roughness": 0.0,
    "clearcoat": 0.36,
    "envMapIntensity": 1.12,
    "reflectivity": 0.95,
    "thumbnailUrl": "/render-assets/materials/metal-pure-gold-sandblasted.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:6406977"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  },
  {
    "id": "metal-5g-gold",
    "label": "5G足金",
    "prefix": "5G_Gold_01_N",
    "swatch": "#e6bd56",
    "color": "#e6bd56",
    "metalness": 1.0,
    "roughness": 0.12,
    "clearcoat": 0.72,
    "envMapIntensity": 1.42,
    "reflectivity": 1.18,
    "thumbnailUrl": "/render-assets/materials/metal-5g-gold.png",
    "baseColorMapUrl": null,
    "normalMapUrl": null,
    "aoMapUrl": null,
    "roughnessMapUrl": null,
    "metalnessMapUrl": null,
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot; material fields use mature API when the named record exists, otherwise conservative local scalar fallback."
  }
];

export const renderGemstoneAssets: RenderGemstoneAsset[] = [
  {
    "id": "gem-light-coffee",
    "label": "浅咖啡石",
    "prefix": "Gemstone_light_coffee",
    "swatch": "#461f0c",
    "color": "#461f0c",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#461f0c",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-light-coffee.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-light-olive",
    "label": "浅橄榄石",
    "prefix": "Gemstone_light_olive",
    "swatch": "#9fa018",
    "color": "#9fa018",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#9fa018",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-light-olive.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-tourmaline-pink",
    "label": "碧玺石",
    "prefix": "Gemstone_Red_Tourmaline_01",
    "swatch": "#b0465c",
    "color": "#b0465c",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#b0465c",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-tourmaline-pink.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612582"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-green-blue",
    "label": "绿蓝宝",
    "prefix": "Gemstone_green_blue",
    "swatch": "#90c4a4",
    "color": "#90c4a4",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#90c4a4",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-green-blue.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-deep-sapphire",
    "label": "深蓝宝石",
    "prefix": "Gemstone_deep_sapphire",
    "swatch": "#194477",
    "color": "#194477",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#194477",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-deep-sapphire.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-cyan-sapphire",
    "label": "青蓝宝石",
    "prefix": "Gemstone_cyan_sapphire",
    "swatch": "#28aeb8",
    "color": "#28aeb8",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#28aeb8",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-cyan-sapphire.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-black",
    "label": "黑宝石",
    "prefix": "Gemstone_black",
    "swatch": "#353535",
    "color": "#353535",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#353535",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-black.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-pink",
    "label": "粉宝石",
    "prefix": "Gemstone_pink",
    "swatch": "#ffd3e9",
    "color": "#ffd3e9",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#ffd3e9",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-pink.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-demantoid",
    "label": "翠榴石",
    "prefix": "Gemstone_demantoid",
    "swatch": "#00a878",
    "color": "#00a878",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#00a878",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-demantoid.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-dark-garnet",
    "label": "暗榴石",
    "prefix": "Gemstone_dark_garnet",
    "swatch": "#461f0c",
    "color": "#461f0c",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#461f0c",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-dark-garnet.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-aquamarine",
    "label": "海蓝宝石",
    "prefix": "Gemstone_aquamarine_01",
    "swatch": "#1b8bb6",
    "color": "#1b8bb6",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#1b8bb6",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-aquamarine.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-brown-red",
    "label": "棕红石",
    "prefix": "Gemstone_brown_red",
    "swatch": "#7f2020",
    "color": "#7f2020",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#7f2020",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-brown-red.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-light-pink",
    "label": "浅粉宝石",
    "prefix": "Gemstone_light_pink",
    "swatch": "#fbddee",
    "color": "#fbddee",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#fbddee",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-light-pink.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-alexandrite",
    "label": "变兰石",
    "prefix": "Gemstone_alexandrite",
    "swatch": "#b4a2d6",
    "color": "#b4a2d6",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#b4a2d6",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-alexandrite.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-deep-purple-red",
    "label": "深紫红石",
    "prefix": "Gemstone_deep_purple_red",
    "swatch": "#5d2582",
    "color": "#5d2582",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#5d2582",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-deep-purple-red.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-deep-ruby",
    "label": "深红宝石",
    "prefix": "Gemstone_deep_ruby",
    "swatch": "#c31414",
    "color": "#c31414",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#c31414",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-deep-ruby.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-diamond",
    "label": "钻石",
    "prefix": "Gemstone_Diamond",
    "swatch": "#FFFFFF",
    "color": "#FFFFFF",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#FFFFFF",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-diamond.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612605"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-light-champagne",
    "label": "浅香槟石",
    "prefix": "Gemstone_light_champagne",
    "swatch": "#e5c052",
    "color": "#e5c052",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#e5c052",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-light-champagne.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-orange",
    "label": "橙宝石",
    "prefix": "Gemstone_citrine_01",
    "swatch": "#e9802f",
    "color": "#e9802f",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#e9802f",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-orange.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "screenshot-only"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-amethyst",
    "label": "紫宝石",
    "prefix": "Gemstone_amethyst_01",
    "swatch": "#81699f",
    "color": "#81699f",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#81699f",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-amethyst.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612603"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-yellow",
    "label": "黄宝石",
    "prefix": "Gemstone_Yellow_01",
    "swatch": "#fdd472",
    "color": "#fdd472",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#fdd472",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-yellow.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612587"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-blue-sapphire",
    "label": "蓝宝石",
    "prefix": "Gemstone_Light_sapphire_01",
    "swatch": "#1958C2",
    "color": "#1958C2",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#1958C2",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-blue-sapphire.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612591"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-ruby",
    "label": "红宝石",
    "prefix": "Gemstone_Light_ruby_01",
    "swatch": "#b9422e",
    "color": "#b9422e",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#b9422e",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-ruby.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612586"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  },
  {
    "id": "gem-emerald",
    "label": "绿宝石",
    "prefix": "Gemstone_Emerald_01",
    "swatch": "#308d55",
    "color": "#308d55",
    "transmission": 0.86,
    "ior": 1.78,
    "thickness": 0.55,
    "roughness": 0.08,
    "envMapIntensity": 1.8,
    "attenuationColor": "#308d55",
    "attenuationDistance": 0.72,
    "dispersion": 0.08,
    "internalColorStrength": 1,
    "outerReflectionMix": 0.55,
    "maxOuterReflection": 0.22,
    "refractionDepth": 0.82,
    "refractionCount": 3,
    "maxReflection": 0.22,
    "mixedReflection": true,
    "thumbnailUrl": "/render-assets/gemstones/gem-emerald.png",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/material + user mature editor screenshot",
      "originalId": "id:5612604"
    },
    "status": "available",
    "notes": "Thumbnail localized from mature render editor screenshot. Current public mature API exposes only part of the 24 visible gemstone records; missing named records are preserved as local visual assets."
  }
];

export const renderHdrAssets: RenderHdrAsset[] = [
  {
    "id": "hdr-scene-1",
    "label": "场景-1",
    "alias": "VRI-7",
    "prefix": "VRI-7",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-1.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-1.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661775"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-2",
    "label": "场景-2",
    "alias": "1",
    "prefix": "黄金1",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-2.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-2.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6008237"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-3",
    "label": "场景-3",
    "alias": "54",
    "prefix": "54",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-3.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-3.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6247715"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-4",
    "label": "场景-4",
    "alias": "A2",
    "prefix": "A2",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-4.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-4.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5612578"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-5",
    "label": "场景-5",
    "alias": "A3",
    "prefix": "A3",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-5.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-5.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5612624"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-6",
    "label": "场景-6",
    "alias": "E-4",
    "prefix": "E-4",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-6.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-6.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661765"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-7",
    "label": "场景-7",
    "alias": "E8",
    "prefix": "E8",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-7.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-7.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661767"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-8",
    "label": "场景-8",
    "alias": "A4",
    "prefix": "A4",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-8.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-8.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661784"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-9",
    "label": "场景-9",
    "alias": "VRI-1",
    "prefix": "VRI-1",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-9.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-9.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661797"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-10",
    "label": "场景-10",
    "alias": "E-3",
    "prefix": "E-3",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-10.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-10.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661800"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-11",
    "label": "场景-11",
    "alias": "A6",
    "prefix": "A6",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-11.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-11.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661803"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-12",
    "label": "场景-12",
    "alias": "F1",
    "prefix": "F1",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-12.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-12.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5661853"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-13",
    "label": "场景-13",
    "alias": "Along1",
    "prefix": "Along1",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-13.jpg",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-13.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5867236"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-14",
    "label": "场景-14",
    "alias": "VNE-1",
    "prefix": "VNE-1",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-14.jpg",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-14.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5867237"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-15",
    "label": "场景-15",
    "alias": "VRI-1.1",
    "prefix": "VRI-1_1",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-15.jpg",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-15.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5867238"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-16",
    "label": "场景-16",
    "alias": "VRI-1.2",
    "prefix": "VRI-1_2",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-16.jpg",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-16.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5867240"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-17",
    "label": "场景-17",
    "alias": "VRI-1.3",
    "prefix": "VRI-1_3",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-17.jpg",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-17.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:5867241"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-18",
    "label": "场景-18",
    "alias": "1",
    "prefix": "1",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-18.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-18.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6150893"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-19",
    "label": "场景-19",
    "alias": "2",
    "prefix": "2",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-19.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-19.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151784"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-20",
    "label": "场景-20",
    "alias": "4",
    "prefix": "4",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-20.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-20.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151788"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-21",
    "label": "场景-21",
    "alias": "5",
    "prefix": "5",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-21.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-21.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151789"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-22",
    "label": "场景-22",
    "alias": "6",
    "prefix": "6",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-22.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-22.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151791"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-23",
    "label": "场景-23",
    "alias": "10",
    "prefix": "10",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-23.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-23.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151796"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-24",
    "label": "场景-24",
    "alias": "11",
    "prefix": "11",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-24.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-24.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151797"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-25",
    "label": "场景-25",
    "alias": "13",
    "prefix": "13",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-25.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-25.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151799"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-26",
    "label": "场景-26",
    "alias": "14",
    "prefix": "14",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-26.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-26.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6151806"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-27",
    "label": "场景-27",
    "alias": "36",
    "prefix": "36",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-27.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-27.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6153508"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-28",
    "label": "场景-28",
    "alias": "37",
    "prefix": "37",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-28.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-28.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6155825"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-29",
    "label": "场景-29",
    "alias": "38",
    "prefix": "38",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-29.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-29.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6211535"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-30",
    "label": "场景-30",
    "alias": "44",
    "prefix": "44",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-30.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-30.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6220244"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-31",
    "label": "场景-31",
    "alias": "46",
    "prefix": "46",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-31.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-31.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6235843"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  },
  {
    "id": "hdr-scene-32",
    "label": "场景-32",
    "alias": "47",
    "prefix": "汪总（小钻）",
    "background": "#050505",
    "thumbnailColor": "#262a2c",
    "exposure": 1.04,
    "environmentIntensity": 1.45,
    "thumbnailUrl": "/render-assets/hdr/thumbs/hdr-scene-32.png",
    "hdrUrl": "/render-assets/hdr/files/hdr-scene-32.hdr",
    "source": {
      "project": "AllWebsite",
      "path": "prodapi:/aidesign/rendering/get/hdr",
      "originalId": "id:6244541"
    },
    "status": "available",
    "notes": "Localized from mature rendering HDR API; editor intentionally keeps the mature-page 32 item baseline."
  }
];

export const renderAssetManifest = {
  metals: renderMetalAssets,
  gemstones: renderGemstoneAssets,
  hdrs: renderHdrAssets,
};
